import { type RefObject } from 'react';
import { layersCanvasRenderer } from './heatmapCanvasRenderer';

const registeredLayers: RefObject<HTMLCanvasElement>[] = [];

export const registerLayer = (canvasRef: RefObject<HTMLCanvasElement>): void => {
  registeredLayers.push(canvasRef);
};

export const unregisterLayer = (canvasRef: RefObject<HTMLCanvasElement>): void => {
  const index = registeredLayers.findIndex((layer) => canvasRef === layer);
  registeredLayers.splice(index, 1);
};

export const getLayersImageData = (quality?: number): string | null => {
  const canvas = layersCanvasRenderer(
    registeredLayers.filter((canvasRef) => canvasRef.current?.style.display !== 'none'),
  );

  if (canvas === null) {
    return null;
  }

  return canvas.toDataURL('image/jpeg', quality);
};
